
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MSALService, AuthStrategy, authSelectors } from '@content-platform/web-angular-shared-util-auth';
import { LoggerService } from '@content-platform/web-angular-shared-util-logging';
import { Store } from '@ngrx/store';
import {
  Observable,
  throwError
} from 'rxjs';
import { catchError, switchMap, filter } from 'rxjs/operators';
import { API_VERSION, GRAPH_SCOPE, GRAPH_URL } from '../graph-api.config';
import { Auth } from './../models/auth';



/**
 * Interceptor for the Graph Api requests, this adds the authorization token and the api version, that should
 * be on every request.
 *
 * @export
 * @class TokenInterceptor
 */
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private logger: LoggerService;

  constructor(private msalService: MSALService,
    loggerService: LoggerService,
    private store: Store<Auth>) {
    this.logger = loggerService.instance('TokenInterceptor');
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(GRAPH_URL)) {
      return next.handle(request);
    }
    return this.store.select(authSelectors.getAuthenticationStrategy).pipe(
      filter(strategy => !!strategy),
      switchMap((authStrategy: AuthStrategy) => {
        const token$: Observable<string> =
          authStrategy === AuthStrategy.OKTA
            ? this.store.select(authSelectors.getGraphToken)
            : this.getToken();
        return token$.pipe(
          switchMap((token) => {
            console.log('🚀🚀 token received for '+ request.url, (token !== undefined)); 
            request = request.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`
              },
              setParams: {
                'api-version': API_VERSION
              }
            }); 
            return next.handle(request).pipe(
              catchError((err: any) => {
                console.log('🚀🚀 ERROR in token interceptor', err);
                if (err instanceof HttpErrorResponse && err.status === 403) {
                  this.logger.error(`403 - ${err.message}`);
                }
                return throwError(err);
              })
            );
          })
        );
      }));
  }

  private getToken(): Observable<string> {
    return Observable.create(observer => {
      this.msalService.acquireToken(`${GRAPH_URL}${GRAPH_SCOPE}`, (_message, token) => {
        observer.next(token);
        observer.complete();
      });
    });
  }
}
